module.exports = __webpack_public_path__ + "static/img/03_cyys.5b3bba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/firstLine/03_cyys.png
// module id = S7ln
// module chunks = 0